import { DATE_FORMAT_OPTIONS } from './constants';

/**
 * Formats an ISO date string for display using the modal's standard format.
 * Returns an empty string for falsy input and the original string for
 * values that don't parse to a valid Date.
 */
export const formatDate = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return isoString;
  return date.toLocaleString(undefined, DATE_FORMAT_OPTIONS);
};

/**
 * Total number of items across all assessments in an `assessmentItems` map.
 */
export const calculateTotalItems = (assessmentItems) =>
  Object.values(assessmentItems || {}).reduce(
    (sum, items) => sum + (items?.length || 0),
    0,
  );

/**
 * Sum of the `points` value for a list of assessment items.
 */
export const sumPoints = (items) =>
  (items || []).reduce((sum, item) => sum + (item?.points || 0), 0);
